import React, {useContext, useEffect, useState} from "react";
import {GateContext} from "../../tools/contexts/GateContext";
import {useNavigate, useSearchParams} from "react-router-dom";
import Button from "../Button";
import {divarLinkGenerator, safeRedirect} from "../../tools/helpers";
import LoadingScreen from "../LoadingScreen";
import FaceImage from "../../images/Authentication/real_face.jpg";
import servicesRoute from "../../tools/servicesRoute";
import ErrorModal from "../modals/ErrorModal";
import {Reoverlay} from "reoverlay";
const DivarFaceAlert = ({onConfirm, onCancel}) => {
    return <div className="w-full flex justify-center items-center h-screen ">
        <div
            className="bg-white shadow-sm w-11/12 flex  justify-center items-center flex-col md:8/12 lg:w-4/12 xl:w-3/12 p-5 rounded-xl">
            <h1 className="text-2xl  font-bold  text-center ">هشدار</h1>
            <p className="text-gray-700 text-sm text-center mb-3 ">اطلاعات هویتی شما نزد ما محفوظ خواهد ماند و تصویر و
                نام شما در آگهی نمایش داده خواهد شد. در صورت نقض قوانین دیوار، این پلتفرم و کاربران متضرر می‌توانند با
                استفاده از این اطلاعات به مراجع قضایی شکایت کنند.
                همچنین در صورت ادعای وارد شدن ضرر از سوی اشخاص ثالث (اعم از حقیقی یا حقوقی)، اطلاعات اظهارشده‌ی شما،
                تصویر و ویدیوی بارگذاری‌شده، حتی بدون دستور قضایی نیز در اختیار ایشان قرار خواهد گرفت.
            </p>
            <div className="my-2 p-3 rounded-lg border bg-gray-100 w-full">
                <div className="flex justify-start  items-center">
                    <div><img src={FaceImage} alt="" className="w-16 rounded-full border"/></div>
                    <div className="flex flex-col mr-2">
                        <p className="font-bold ">تأیید هویت شده</p>
                        <p className="text-sm ">نام و نام خانوادگی شما</p>
                    </div>
                </div>
            </div>
            <div className={`w-full mt-5 grid gap-2 items-  grid-cols-2`}>
                <Button onClick={onConfirm} rounded="rounded-lg" theme={"green"} className="text-sm">تأیید</Button>
                <Button onClick={onCancel} rounded="rounded-lg" theme={"link"} className="text-sm">بازگشت به
                    دیوار</Button>
            </div>
        </div>

    </div>;
}
const DivarInternalAuthGate = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const hasPostAddon = searchParams.get('has_post_addon');
    const hasUserAddon = searchParams.get('has_user_addon');
    const [showDivarAlert, setShowDivarAlert] = useState(false);
    const {
        id,
        serviceType,
        postToken,
        returnUrl,
        loading,
        handleGetPlatformLink,
        code,
        ticketUuid,
        handlePlatformGuard
    } = useContext(GateContext);
    const onConfirm = () => {
        localStorage.clear();
        sessionStorage.clear();
        if (returnUrl) {
            sessionStorage.setItem('return_url', returnUrl);
        }
        if (postToken) {
            sessionStorage.setItem('post_token', postToken);
        }
        if (ticketUuid) {
            sessionStorage.setItem('ticket_uuid', ticketUuid);
        }
        if (hasUserAddon) {
            sessionStorage.setItem('has_user_addon', hasUserAddon)
        }
        if (hasPostAddon) {
            sessionStorage.setItem('has_post_addon', hasPostAddon)
        }
        if (id) {
            sessionStorage.setItem('id', id);
        }
        const params = {
            post_token: ticketUuid ? ticketUuid : null,
            ad_post_token: hasPostAddon ? postToken : null,
            service_type: serviceType,
            platform_hash_id: id,
            is_user_add_on: hasUserAddon==='1',

        }

        handleGetPlatformLink(params);
    }

    useEffect(() => {
        if (code) {

            const params = {
                "service_type": serviceType,
                "platform_hash_id": id,
                "code": code,
                "post_token": sessionStorage.getItem('ticket_uuid'),
                "ad_post_token": sessionStorage.getItem('has_post_addon') === "1" ? sessionStorage.getItem('post_token') : null,
            };
            handlePlatformGuard(params, (data) => {

                //on success
                sessionStorage.setItem('token', data.access_token);
                sessionStorage.setItem('platformUser', JSON.stringify(data.platform_user));
                sessionStorage.setItem('service_type', serviceType);
                navigate(servicesRoute[serviceType].path, {
                    state: {
                        access_token: data.access_token,
                        platform: data.client_name,
                        platform_user: data.platform_user,
                        mobile: data.platform_user.phone_number,
                        defaultService: serviceType,
                    }, replace: true
                })
            })
        } else {
            if (hasUserAddon === "1" || hasPostAddon === "1") {
                //show warning to user before get access link
                setShowDivarAlert(true);
            } else {
                // get access link ( getPlatform link )
                onConfirm();
            }
        }
    }, []);

    const onCancel = () => {
        const link=divarLinkGenerator({
            returnUrl,
        },true);
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal, {
                showConfirmButton: true,
                confirmButtonText: 'بستن',
                confirmButtonTheme: 'red',
                title: 'خطا',
                message: 'لینک معتبر نمی باشد.',
                onConfirm: () => {
                    Reoverlay.hideModal();
                    navigate('/404')
                }
            })
        })

    }
    if (loading) {
        return <LoadingScreen/>
    }
    if (showDivarAlert) {
        return <DivarFaceAlert onCancel={onCancel} onConfirm={onConfirm}/>
    }

    return <div></div>
}

export default DivarInternalAuthGate;